export default function HeroSection() {
  return (
    <section className="relative min-h-[480px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/60f0662ca1432a39cb79e18d6ed80ce7.jpg"
          alt="Students celebrating success"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-400/40 text-emerald-300 text-sm font-semibold px-4 py-2 rounded-full mb-6 backdrop-blur-sm">
          <i className="ri-trophy-line"></i>
          Real Students. Real Results.
        </div>
        <h1 className="text-5xl font-extrabold text-white mb-5 leading-tight">
          Student Success Stories &amp; <br />
          <span className="text-emerald-400">Grade Transformations</span>
        </h1>
        <p className="text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          See how students across every grade level went from struggling to thriving — with real before-and-after scores, timelines, and stories in their own words.
        </p>
      </div>
    </section>
  );
}
